import $3d5058299051dde5$exports from "./ar-AE.mjs";
import $b09fec806b7b8f22$exports from "./bg-BG.mjs";
import $ca0549dfb1669363$exports from "./cs-CZ.mjs";
import $98f2907c0694c5b6$exports from "./da-DK.mjs";
import $9d6fce77106482c8$exports from "./de-DE.mjs";
import $db5c63cb8d95d7a4$exports from "./el-GR.mjs";
import $94e4262f3b79d866$exports from "./en-US.mjs";
import $16cf2bb6affc1ca9$exports from "./es-ES.mjs";
import $d2a4cd1ccd3b9660$exports from "./et-EE.mjs";
import $0aa3ceafb597db1b$exports from "./fi-FI.mjs";
import $5779b104f19b7b1a$exports from "./fr-FR.mjs";
import $33aba885fd306c4d$exports from "./he-IL.mjs";
import $30a099a3f19b59af$exports from "./hr-HR.mjs";
import $f257504b02c6b23f$exports from "./hu-HU.mjs";
import $b6e12833733478ab$exports from "./it-IT.mjs";
import $e69fac8c5f9d6043$exports from "./ja-JP.mjs";
import $a9b740b7d23548d0$exports from "./ko-KR.mjs";
import $4d8ca888adc67de0$exports from "./lt-LT.mjs";
import $5d3a845adaaa328a$exports from "./lv-LV.mjs";
import $20112446b2d06d6e$exports from "./nb-NO.mjs";
import $168501f8ff8ad607$exports from "./nl-NL.mjs";
import $7d885e2935e9ed01$exports from "./pl-PL.mjs";
import $ece77a10c9739c65$exports from "./pt-BR.mjs";
import $8dbae7e3487e6fc7$exports from "./pt-PT.mjs";
import $4ab371254445a3f4$exports from "./ro-RO.mjs";
import $c5ac7ec630c67dba$exports from "./ru-RU.mjs";
import $846eaea7e21f7fbf$exports from "./sk-SK.mjs";
import $dde062d6acd4e43a$exports from "./sl-SI.mjs";
import $579b7ae9c5494112$exports from "./sr-SP.mjs";
import $3b62c0bcc6cf3c98$exports from "./sv-SE.mjs";
import $31f966e58b99834b$exports from "./tr-TR.mjs";
import $a3d99ea5d46a3d12$exports from "./uk-UA.mjs";
import $6e4b63af77288b7a$exports from "./zh-CN.mjs";
import $be993a68bccef72a$exports from "./zh-TW.mjs";
import "./main.css";
import {useSlotProps as $d7FTw$useSlotProps, useFocusableRef as $d7FTw$useFocusableRef, useStyleProps as $d7FTw$useStyleProps, useHasChild as $d7FTw$useHasChild, classNames as $d7FTw$classNames, SlotProvider as $d7FTw$SlotProvider} from "@react-spectrum/utils";
import {FocusRing as $d7FTw$FocusRing} from "@react-aria/focus";
import {useId as $d7FTw$useId, isAppleDevice as $d7FTw$isAppleDevice, isFirefox as $d7FTw$isFirefox, mergeProps as $d7FTw$mergeProps} from "@react-aria/utils";
import {ProgressCircle as $d7FTw$ProgressCircle} from "@react-spectrum/progress";
import $d7FTw$react, {useState as $d7FTw$useState, useEffect as $d7FTw$useEffect} from "react";
import {Text as $d7FTw$Text} from "@react-spectrum/text";
import {useButton as $d7FTw$useButton, useToggleButton as $d7FTw$useToggleButton} from "@react-aria/button";
import {useHover as $d7FTw$useHover, useFocus as $d7FTw$useFocus} from "@react-aria/interactions";
import {useLocalizedStringFormatter as $d7FTw$useLocalizedStringFormatter} from "@react-aria/i18n";
import {useProviderProps as $d7FTw$useProviderProps} from "@react-spectrum/provider";
import $d7FTw$spectrumiconsuiCornerTriangle from "@spectrum-icons/ui/CornerTriangle";
import $d7FTw$spectrumiconsuiCrossSmall from "@spectrum-icons/ui/CrossSmall";
import {useToggleState as $d7FTw$useToggleState} from "@react-stately/toggle";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 

var $94fed84ca44dbd5b$exports = {};


































$94fed84ca44dbd5b$exports = {
    "ar-AE": $3d5058299051dde5$exports,
    "bg-BG": $b09fec806b7b8f22$exports,
    "cs-CZ": $ca0549dfb1669363$exports,
    "da-DK": $98f2907c0694c5b6$exports,
    "de-DE": $9d6fce77106482c8$exports,
    "el-GR": $db5c63cb8d95d7a4$exports,
    "en-US": $94e4262f3b79d866$exports,
    "es-ES": $16cf2bb6affc1ca9$exports,
    "et-EE": $d2a4cd1ccd3b9660$exports,
    "fi-FI": $0aa3ceafb597db1b$exports,
    "fr-FR": $5779b104f19b7b1a$exports,
    "he-IL": $33aba885fd306c4d$exports,
    "hr-HR": $30a099a3f19b59af$exports,
    "hu-HU": $f257504b02c6b23f$exports,
    "it-IT": $b6e12833733478ab$exports,
    "ja-JP": $e69fac8c5f9d6043$exports,
    "ko-KR": $a9b740b7d23548d0$exports,
    "lt-LT": $4d8ca888adc67de0$exports,
    "lv-LV": $5d3a845adaaa328a$exports,
    "nb-NO": $20112446b2d06d6e$exports,
    "nl-NL": $168501f8ff8ad607$exports,
    "pl-PL": $7d885e2935e9ed01$exports,
    "pt-BR": $ece77a10c9739c65$exports,
    "pt-PT": $8dbae7e3487e6fc7$exports,
    "ro-RO": $4ab371254445a3f4$exports,
    "ru-RU": $c5ac7ec630c67dba$exports,
    "sk-SK": $846eaea7e21f7fbf$exports,
    "sl-SI": $dde062d6acd4e43a$exports,
    "sr-SP": $579b7ae9c5494112$exports,
    "sv-SE": $3b62c0bcc6cf3c98$exports,
    "tr-TR": $31f966e58b99834b$exports,
    "uk-UA": $a3d99ea5d46a3d12$exports,
    "zh-CN": $6e4b63af77288b7a$exports,
    "zh-TW": $be993a68bccef72a$exports
};





var $086e93d2352a4536$exports = {};

$parcel$export($086e93d2352a4536$exports, "focus-ring", () => $086e93d2352a4536$export$f39a09f249340e2a, (v) => $086e93d2352a4536$export$f39a09f249340e2a = v);
$parcel$export($086e93d2352a4536$exports, "i18nFontFamily", () => $086e93d2352a4536$export$8c4ee2c50c22c514, (v) => $086e93d2352a4536$export$8c4ee2c50c22c514 = v);
$parcel$export($086e93d2352a4536$exports, "is-active", () => $086e93d2352a4536$export$20fd0f7cd4e6112f, (v) => $086e93d2352a4536$export$20fd0f7cd4e6112f = v);
$parcel$export($086e93d2352a4536$exports, "is-disabled", () => $086e93d2352a4536$export$d35bc1e505d1ebbf, (v) => $086e93d2352a4536$export$d35bc1e505d1ebbf = v);
$parcel$export($086e93d2352a4536$exports, "is-focused", () => $086e93d2352a4536$export$e7dc768d35940237, (v) => $086e93d2352a4536$export$e7dc768d35940237 = v);
$parcel$export($086e93d2352a4536$exports, "is-hovered", () => $086e93d2352a4536$export$b8813cd5d7824ce7, (v) => $086e93d2352a4536$export$b8813cd5d7824ce7 = v);
$parcel$export($086e93d2352a4536$exports, "is-open", () => $086e93d2352a4536$export$a9781837241c946d, (v) => $086e93d2352a4536$export$a9781837241c946d = v);
$parcel$export($086e93d2352a4536$exports, "is-placeholder", () => $086e93d2352a4536$export$e5b2f5233e4e5194, (v) => $086e93d2352a4536$export$e5b2f5233e4e5194 = v);
$parcel$export($086e93d2352a4536$exports, "is-selected", () => $086e93d2352a4536$export$1e0fb04f31d3c22a, (v) => $086e93d2352a4536$export$1e0fb04f31d3c22a = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-BaseButton", () => $086e93d2352a4536$export$f7b415378ab4f839, (v) => $086e93d2352a4536$export$f7b415378ab4f839 = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-FocusRing-ring", () => $086e93d2352a4536$export$4109102f950813a6, (v) => $086e93d2352a4536$export$4109102f950813a6 = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-FocusRing", () => $086e93d2352a4536$export$24c7f46a6e3605dd, (v) => $086e93d2352a4536$export$24c7f46a6e3605dd = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-ActionButton", () => $086e93d2352a4536$export$53da69f51b770d3, (v) => $086e93d2352a4536$export$53da69f51b770d3 = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-ActionButton--emphasized", () => $086e93d2352a4536$export$5aabb61a966e266f, (v) => $086e93d2352a4536$export$5aabb61a966e266f = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-ActionButton--quiet", () => $086e93d2352a4536$export$40e1f009544bacf3, (v) => $086e93d2352a4536$export$40e1f009544bacf3 = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-ActionButton--staticBlack", () => $086e93d2352a4536$export$8f7c9db66978d20f, (v) => $086e93d2352a4536$export$8f7c9db66978d20f = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-ActionButton--staticColor", () => $086e93d2352a4536$export$29b7b5d6a5a497c5, (v) => $086e93d2352a4536$export$29b7b5d6a5a497c5 = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-ActionButton--staticWhite", () => $086e93d2352a4536$export$ccc536e1adbdc059, (v) => $086e93d2352a4536$export$ccc536e1adbdc059 = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-ActionButton-hold", () => $086e93d2352a4536$export$4a4f01c443eff992, (v) => $086e93d2352a4536$export$4a4f01c443eff992 = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-ActionButton-label", () => $086e93d2352a4536$export$ebb4635c66bacdb9, (v) => $086e93d2352a4536$export$ebb4635c66bacdb9 = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-Button", () => $086e93d2352a4536$export$1db4cca5b4ade39a, (v) => $086e93d2352a4536$export$1db4cca5b4ade39a = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-Button--iconOnly", () => $086e93d2352a4536$export$c1d306ec0fae3838, (v) => $086e93d2352a4536$export$c1d306ec0fae3838 = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-Button--overBackground", () => $086e93d2352a4536$export$5cda1128f9112d2e, (v) => $086e93d2352a4536$export$5cda1128f9112d2e = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-Button--pending", () => $086e93d2352a4536$export$54592d0984f245d5, (v) => $086e93d2352a4536$export$54592d0984f245d5 = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-Button-circleLoader", () => $086e93d2352a4536$export$76d4531f0342bbe0, (v) => $086e93d2352a4536$export$76d4531f0342bbe0 = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-Button-label", () => $086e93d2352a4536$export$c081ba562e204942, (v) => $086e93d2352a4536$export$c081ba562e204942 = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-ClearButton", () => $086e93d2352a4536$export$b752ce409e5660c, (v) => $086e93d2352a4536$export$b752ce409e5660c = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-ClearButton--overBackground", () => $086e93d2352a4536$export$116f2fccf941d34d, (v) => $086e93d2352a4536$export$116f2fccf941d34d = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-ClearButton--small", () => $086e93d2352a4536$export$49280ffa5236ba8b, (v) => $086e93d2352a4536$export$49280ffa5236ba8b = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-FieldButton", () => $086e93d2352a4536$export$a024c99ecf6b5741, (v) => $086e93d2352a4536$export$a024c99ecf6b5741 = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-FieldButton--invalid", () => $086e93d2352a4536$export$c9f503f672e8a3c1, (v) => $086e93d2352a4536$export$c9f503f672e8a3c1 = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-FocusRing--quiet", () => $086e93d2352a4536$export$2927016961429360, (v) => $086e93d2352a4536$export$2927016961429360 = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-FieldButton--quiet", () => $086e93d2352a4536$export$5ca7b274e4fff9fc, (v) => $086e93d2352a4536$export$5ca7b274e4fff9fc = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-Icon", () => $086e93d2352a4536$export$d374b04f30360026, (v) => $086e93d2352a4536$export$d374b04f30360026 = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-LogicButton", () => $086e93d2352a4536$export$36ae67a131730482, (v) => $086e93d2352a4536$export$36ae67a131730482 = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-LogicButton--and", () => $086e93d2352a4536$export$e52daab43a62c528, (v) => $086e93d2352a4536$export$e52daab43a62c528 = v);
$parcel$export($086e93d2352a4536$exports, "spectrum-LogicButton--or", () => $086e93d2352a4536$export$da76be6126aaa633, (v) => $086e93d2352a4536$export$da76be6126aaa633 = v);
var $086e93d2352a4536$export$f39a09f249340e2a;
var $086e93d2352a4536$export$8c4ee2c50c22c514;
var $086e93d2352a4536$export$20fd0f7cd4e6112f;
var $086e93d2352a4536$export$d35bc1e505d1ebbf;
var $086e93d2352a4536$export$e7dc768d35940237;
var $086e93d2352a4536$export$b8813cd5d7824ce7;
var $086e93d2352a4536$export$a9781837241c946d;
var $086e93d2352a4536$export$e5b2f5233e4e5194;
var $086e93d2352a4536$export$1e0fb04f31d3c22a;
var $086e93d2352a4536$export$f7b415378ab4f839;
var $086e93d2352a4536$export$4109102f950813a6;
var $086e93d2352a4536$export$24c7f46a6e3605dd;
var $086e93d2352a4536$export$53da69f51b770d3;
var $086e93d2352a4536$export$5aabb61a966e266f;
var $086e93d2352a4536$export$40e1f009544bacf3;
var $086e93d2352a4536$export$8f7c9db66978d20f;
var $086e93d2352a4536$export$29b7b5d6a5a497c5;
var $086e93d2352a4536$export$ccc536e1adbdc059;
var $086e93d2352a4536$export$4a4f01c443eff992;
var $086e93d2352a4536$export$ebb4635c66bacdb9;
var $086e93d2352a4536$export$1db4cca5b4ade39a;
var $086e93d2352a4536$export$c1d306ec0fae3838;
var $086e93d2352a4536$export$5cda1128f9112d2e;
var $086e93d2352a4536$export$54592d0984f245d5;
var $086e93d2352a4536$export$76d4531f0342bbe0;
var $086e93d2352a4536$export$c081ba562e204942;
var $086e93d2352a4536$export$b752ce409e5660c;
var $086e93d2352a4536$export$116f2fccf941d34d;
var $086e93d2352a4536$export$49280ffa5236ba8b;
var $086e93d2352a4536$export$a024c99ecf6b5741;
var $086e93d2352a4536$export$c9f503f672e8a3c1;
var $086e93d2352a4536$export$2927016961429360;
var $086e93d2352a4536$export$5ca7b274e4fff9fc;
var $086e93d2352a4536$export$d374b04f30360026;
var $086e93d2352a4536$export$36ae67a131730482;
var $086e93d2352a4536$export$e52daab43a62c528;
var $086e93d2352a4536$export$da76be6126aaa633;
$086e93d2352a4536$export$f39a09f249340e2a = `Dniwja_focus-ring`;
$086e93d2352a4536$export$8c4ee2c50c22c514 = `Dniwja_i18nFontFamily`;
$086e93d2352a4536$export$20fd0f7cd4e6112f = `Dniwja_is-active`;
$086e93d2352a4536$export$d35bc1e505d1ebbf = `Dniwja_is-disabled`;
$086e93d2352a4536$export$e7dc768d35940237 = `Dniwja_is-focused`;
$086e93d2352a4536$export$b8813cd5d7824ce7 = `Dniwja_is-hovered`;
$086e93d2352a4536$export$a9781837241c946d = `Dniwja_is-open`;
$086e93d2352a4536$export$e5b2f5233e4e5194 = `Dniwja_is-placeholder`;
$086e93d2352a4536$export$1e0fb04f31d3c22a = `Dniwja_is-selected`;
$086e93d2352a4536$export$f7b415378ab4f839 = `Dniwja_spectrum-BaseButton ${$086e93d2352a4536$export$8c4ee2c50c22c514}`;
$086e93d2352a4536$export$4109102f950813a6 = `Dniwja_spectrum-FocusRing-ring`;
$086e93d2352a4536$export$24c7f46a6e3605dd = `Dniwja_spectrum-FocusRing ${$086e93d2352a4536$export$4109102f950813a6}`;
$086e93d2352a4536$export$53da69f51b770d3 = `Dniwja_spectrum-ActionButton ${$086e93d2352a4536$export$f7b415378ab4f839} ${$086e93d2352a4536$export$24c7f46a6e3605dd}`;
$086e93d2352a4536$export$5aabb61a966e266f = `Dniwja_spectrum-ActionButton--emphasized`;
$086e93d2352a4536$export$40e1f009544bacf3 = `Dniwja_spectrum-ActionButton--quiet`;
$086e93d2352a4536$export$8f7c9db66978d20f = `Dniwja_spectrum-ActionButton--staticBlack`;
$086e93d2352a4536$export$29b7b5d6a5a497c5 = `Dniwja_spectrum-ActionButton--staticColor`;
$086e93d2352a4536$export$ccc536e1adbdc059 = `Dniwja_spectrum-ActionButton--staticWhite`;
$086e93d2352a4536$export$4a4f01c443eff992 = `Dniwja_spectrum-ActionButton-hold`;
$086e93d2352a4536$export$ebb4635c66bacdb9 = `Dniwja_spectrum-ActionButton-label`;
$086e93d2352a4536$export$1db4cca5b4ade39a = `Dniwja_spectrum-Button ${$086e93d2352a4536$export$f7b415378ab4f839} ${$086e93d2352a4536$export$24c7f46a6e3605dd}`;
$086e93d2352a4536$export$c1d306ec0fae3838 = `Dniwja_spectrum-Button--iconOnly`;
$086e93d2352a4536$export$5cda1128f9112d2e = `Dniwja_spectrum-Button--overBackground`;
$086e93d2352a4536$export$54592d0984f245d5 = `Dniwja_spectrum-Button--pending`;
$086e93d2352a4536$export$76d4531f0342bbe0 = `Dniwja_spectrum-Button-circleLoader`;
$086e93d2352a4536$export$c081ba562e204942 = `Dniwja_spectrum-Button-label`;
$086e93d2352a4536$export$b752ce409e5660c = `Dniwja_spectrum-ClearButton ${$086e93d2352a4536$export$f7b415378ab4f839} ${$086e93d2352a4536$export$24c7f46a6e3605dd}`;
$086e93d2352a4536$export$116f2fccf941d34d = `Dniwja_spectrum-ClearButton--overBackground`;
$086e93d2352a4536$export$49280ffa5236ba8b = `Dniwja_spectrum-ClearButton--small`;
$086e93d2352a4536$export$a024c99ecf6b5741 = `Dniwja_spectrum-FieldButton ${$086e93d2352a4536$export$f7b415378ab4f839} ${$086e93d2352a4536$export$24c7f46a6e3605dd}`;
$086e93d2352a4536$export$c9f503f672e8a3c1 = `Dniwja_spectrum-FieldButton--invalid`;
$086e93d2352a4536$export$2927016961429360 = `Dniwja_spectrum-FocusRing--quiet`;
$086e93d2352a4536$export$5ca7b274e4fff9fc = `Dniwja_spectrum-FieldButton--quiet ${$086e93d2352a4536$export$2927016961429360}`;
$086e93d2352a4536$export$d374b04f30360026 = `Dniwja_spectrum-Icon`;
$086e93d2352a4536$export$36ae67a131730482 = `Dniwja_spectrum-LogicButton ${$086e93d2352a4536$export$f7b415378ab4f839} ${$086e93d2352a4536$export$24c7f46a6e3605dd}`;
$086e93d2352a4536$export$e52daab43a62c528 = `Dniwja_spectrum-LogicButton--and`;
$086e93d2352a4536$export$da76be6126aaa633 = `Dniwja_spectrum-LogicButton--or`;







function $b865a6f0049e2d66$var$disablePendingProps(props) {
    // Don't allow interaction while isPending is true
    if (props.isPending) {
        props.onPress = undefined;
        props.onPressStart = undefined;
        props.onPressEnd = undefined;
        props.onPressChange = undefined;
        props.onPressUp = undefined;
        props.onKeyDown = undefined;
        props.onKeyUp = undefined;
        props.onClick = undefined;
        props.href = undefined;
    }
    return props;
}
function $b865a6f0049e2d66$var$Button(props, ref) {
    var _buttonProps_arialabelledby;
    props = (0, $d7FTw$useProviderProps)(props);
    props = (0, $d7FTw$useSlotProps)(props, "button");
    props = $b865a6f0049e2d66$var$disablePendingProps(props);
    let { elementType: Element = "button", children: children, variant: variant, style: style = variant === "accent" || variant === "cta" ? "fill" : "outline", staticColor: staticColor, isDisabled: isDisabled, isPending: isPending, autoFocus: autoFocus, ...otherProps } = props;
    let domRef = (0, $d7FTw$useFocusableRef)(ref);
    let { buttonProps: buttonProps, isPressed: isPressed } = (0, $d7FTw$useButton)(props, domRef);
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $d7FTw$useHover)({
        isDisabled: isDisabled
    });
    let [isFocused, onFocusChange] = (0, $d7FTw$useState)(false);
    let { focusProps: focusProps } = (0, $d7FTw$useFocus)({
        onFocusChange: onFocusChange,
        isDisabled: isDisabled
    });
    let stringFormatter = (0, $d7FTw$useLocalizedStringFormatter)((0, (/*@__PURE__*/$parcel$interopDefault($94fed84ca44dbd5b$exports))), "@react-spectrum/button");
    let { styleProps: styleProps } = (0, $d7FTw$useStyleProps)(otherProps);
    let hasLabel = (0, $d7FTw$useHasChild)(`.${(0, (/*@__PURE__*/$parcel$interopDefault($086e93d2352a4536$exports)))["spectrum-Button-label"]}`, domRef);
    let hasIcon = (0, $d7FTw$useHasChild)(`.${(0, (/*@__PURE__*/$parcel$interopDefault($086e93d2352a4536$exports)))["spectrum-Icon"]}`, domRef);
    // an aria label will block children and their labels from being read, this is undesirable for pending state
    let hasAriaLabel = !!buttonProps["aria-label"] || !!buttonProps["aria-labelledby"];
    let [isProgressVisible, setIsProgressVisible] = (0, $d7FTw$useState)(false);
    let backupButtonId = (0, $d7FTw$useId)();
    let buttonId = buttonProps.id || backupButtonId;
    let iconId = (0, $d7FTw$useId)();
    let textId = (0, $d7FTw$useId)();
    let spinnerId = (0, $d7FTw$useId)();
    (0, $d7FTw$useEffect)(()=>{
        let timeout;
        if (isPending) // Start timer when isPending is set to true.
        timeout = setTimeout(()=>{
            setIsProgressVisible(true);
        }, 1000);
        else // Exit loading state when isPending is set to false. */
        setIsProgressVisible(false);
        return ()=>{
            // Clean up on unmount or when user removes isPending prop before entering loading state.
            clearTimeout(timeout);
        };
    }, [
        isPending
    ]);
    if (variant === "cta") variant = "accent";
    else if (variant === "overBackground") {
        variant = "primary";
        staticColor = "white";
    }
    const isPendingAriaLiveLabel = `${hasAriaLabel ? buttonProps["aria-label"] : ""} ${stringFormatter.format("pending")}`.trim();
    var _buttonProps_arialabelledby_replace;
    const isPendingAriaLiveLabelledby = hasAriaLabel ? (_buttonProps_arialabelledby_replace = (_buttonProps_arialabelledby = buttonProps["aria-labelledby"]) === null || _buttonProps_arialabelledby === void 0 ? void 0 : _buttonProps_arialabelledby.replace(buttonId, spinnerId)) !== null && _buttonProps_arialabelledby_replace !== void 0 ? _buttonProps_arialabelledby_replace : spinnerId : `${hasIcon ? iconId : ""} ${hasLabel ? textId : ""} ${spinnerId}`.trim();
    let ariaLive = "polite";
    if ((0, $d7FTw$isAppleDevice)() && (!hasAriaLabel || (0, $d7FTw$isFirefox)())) ariaLive = "off";
    return /*#__PURE__*/ (0, $d7FTw$react).createElement((0, $d7FTw$FocusRing), {
        focusRingClass: (0, $d7FTw$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($086e93d2352a4536$exports))), "focus-ring"),
        autoFocus: autoFocus
    }, /*#__PURE__*/ (0, $d7FTw$react).createElement(Element, {
        ...styleProps,
        ...(0, $d7FTw$mergeProps)(buttonProps, hoverProps, focusProps),
        id: buttonId,
        ref: domRef,
        "data-variant": variant,
        "data-style": style,
        "data-static-color": staticColor || undefined,
        "aria-disabled": isPending ? "true" : undefined,
        "aria-label": isPending ? isPendingAriaLiveLabel : buttonProps["aria-label"],
        "aria-labelledby": isPending ? isPendingAriaLiveLabelledby : buttonProps["aria-labelledby"],
        className: (0, $d7FTw$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($086e93d2352a4536$exports))), "spectrum-Button", {
            "spectrum-Button--iconOnly": hasIcon && !hasLabel,
            "is-disabled": isDisabled || isProgressVisible,
            "is-active": isPressed,
            "is-hovered": isHovered,
            "spectrum-Button--pending": isProgressVisible
        }, styleProps.className)
    }, /*#__PURE__*/ (0, $d7FTw$react).createElement((0, $d7FTw$SlotProvider), {
        slots: {
            icon: {
                id: iconId,
                size: "S",
                UNSAFE_className: (0, $d7FTw$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($086e93d2352a4536$exports))), "spectrum-Icon")
            },
            text: {
                id: textId,
                UNSAFE_className: (0, $d7FTw$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($086e93d2352a4536$exports))), "spectrum-Button-label")
            }
        }
    }, typeof children === "string" ? /*#__PURE__*/ (0, $d7FTw$react).createElement((0, $d7FTw$Text), null, children) : children, isPending && /*#__PURE__*/ (0, $d7FTw$react).createElement("div", {
        "aria-hidden": "true",
        style: {
            visibility: isProgressVisible ? "visible" : "hidden"
        },
        className: (0, $d7FTw$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($086e93d2352a4536$exports))), "spectrum-Button-circleLoader")
    }, /*#__PURE__*/ (0, $d7FTw$react).createElement((0, $d7FTw$ProgressCircle), {
        "aria-label": isPendingAriaLiveLabel,
        isIndeterminate: true,
        size: "S",
        staticColor: staticColor
    })), isPending && /*#__PURE__*/ (0, $d7FTw$react).createElement((0, $d7FTw$react).Fragment, null, /*#__PURE__*/ (0, $d7FTw$react).createElement("div", {
        "aria-live": isFocused ? ariaLive : "off"
    }, isProgressVisible && /*#__PURE__*/ (0, $d7FTw$react).createElement("div", {
        role: "img",
        "aria-labelledby": isPendingAriaLiveLabelledby
    })), /*#__PURE__*/ (0, $d7FTw$react).createElement("div", {
        id: spinnerId,
        role: "img",
        "aria-label": isPendingAriaLiveLabel
    })))));
}
/**
 * Buttons allow users to perform an action or to navigate to another page.
 * They have multiple styles for various needs, and are ideal for calling attention to
 * where a user needs to do something in order to move forward in a flow.
 */ let $b865a6f0049e2d66$export$353f5b6fc5456de1 = /*#__PURE__*/ (0, $d7FTw$react).forwardRef($b865a6f0049e2d66$var$Button);


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 









function $042ad0b3a4a55b33$var$ActionButton(props, ref) {
    props = (0, $d7FTw$useProviderProps)(props);
    props = (0, $d7FTw$useSlotProps)(props, "actionButton");
    let { isQuiet: isQuiet, isDisabled: isDisabled, staticColor: staticColor, children: children, autoFocus: autoFocus, holdAffordance: // @ts-ignore (private)
    holdAffordance, ...otherProps } = props;
    let domRef = (0, $d7FTw$useFocusableRef)(ref);
    let { buttonProps: buttonProps, isPressed: isPressed } = (0, $d7FTw$useButton)(props, domRef);
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $d7FTw$useHover)({
        isDisabled: isDisabled
    });
    let { styleProps: styleProps } = (0, $d7FTw$useStyleProps)(otherProps);
    let isTextOnly = (0, $d7FTw$react).Children.toArray(props.children).every((c)=>!/*#__PURE__*/ (0, $d7FTw$react).isValidElement(c));
    return /*#__PURE__*/ (0, $d7FTw$react).createElement((0, $d7FTw$FocusRing), {
        focusRingClass: (0, $d7FTw$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($086e93d2352a4536$exports))), "focus-ring"),
        autoFocus: autoFocus
    }, /*#__PURE__*/ (0, $d7FTw$react).createElement("button", {
        ...styleProps,
        ...(0, $d7FTw$mergeProps)(buttonProps, hoverProps),
        ref: domRef,
        className: (0, $d7FTw$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($086e93d2352a4536$exports))), "spectrum-ActionButton", {
            "spectrum-ActionButton--quiet": isQuiet,
            "spectrum-ActionButton--staticColor": !!staticColor,
            "spectrum-ActionButton--staticWhite": staticColor === "white",
            "spectrum-ActionButton--staticBlack": staticColor === "black",
            "is-active": isPressed,
            "is-disabled": isDisabled,
            "is-hovered": isHovered
        }, styleProps.className)
    }, holdAffordance && /*#__PURE__*/ (0, $d7FTw$react).createElement((0, $d7FTw$spectrumiconsuiCornerTriangle), {
        UNSAFE_className: (0, $d7FTw$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($086e93d2352a4536$exports))), "spectrum-ActionButton-hold")
    }), /*#__PURE__*/ (0, $d7FTw$react).createElement((0, $d7FTw$SlotProvider), {
        slots: {
            icon: {
                size: "S",
                UNSAFE_className: (0, $d7FTw$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($086e93d2352a4536$exports))), "spectrum-Icon")
            },
            text: {
                UNSAFE_className: (0, $d7FTw$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($086e93d2352a4536$exports))), "spectrum-ActionButton-label")
            }
        }
    }, typeof children === "string" || isTextOnly ? /*#__PURE__*/ (0, $d7FTw$react).createElement((0, $d7FTw$Text), null, children) : children)));
}
/**
 * ActionButtons allow users to perform an action.
 * They’re used for similar, task-based options within a workflow, and are ideal for interfaces where buttons aren’t meant to draw a lot of attention.
 */ let $042ad0b3a4a55b33$export$cfc7921d29ef7b80 = /*#__PURE__*/ (0, $d7FTw$react).forwardRef($042ad0b3a4a55b33$var$ActionButton);


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 






// @private
function $b43bd559b476d0c4$var$FieldButton(props, ref) {
    props = (0, $d7FTw$useSlotProps)(props, "button");
    let { isQuiet: isQuiet, isDisabled: isDisabled, validationState: validationState, isInvalid: isInvalid, children: children, autoFocus: autoFocus, isActive: isActive, focusRingClass: focusRingClass, ...otherProps } = props;
    let domRef = (0, $d7FTw$useFocusableRef)(ref);
    let { buttonProps: buttonProps, isPressed: isPressed } = (0, $d7FTw$useButton)(props, domRef);
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $d7FTw$useHover)({
        isDisabled: isDisabled
    });
    let { styleProps: styleProps } = (0, $d7FTw$useStyleProps)(otherProps);
    return /*#__PURE__*/ (0, $d7FTw$react).createElement((0, $d7FTw$FocusRing), {
        focusRingClass: (0, $d7FTw$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($086e93d2352a4536$exports))), "focus-ring", focusRingClass),
        autoFocus: autoFocus
    }, /*#__PURE__*/ (0, $d7FTw$react).createElement("button", {
        ...(0, $d7FTw$mergeProps)(buttonProps, hoverProps),
        ref: domRef,
        className: (0, $d7FTw$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($086e93d2352a4536$exports))), "spectrum-FieldButton", {
            "spectrum-FieldButton--quiet": isQuiet,
            "is-active": isActive || isPressed,
            "is-disabled": isDisabled,
            "spectrum-FieldButton--invalid": isInvalid || validationState === "invalid",
            "is-hovered": isHovered
        }, styleProps.className)
    }, /*#__PURE__*/ (0, $d7FTw$react).createElement((0, $d7FTw$SlotProvider), {
        slots: {
            icon: {
                size: "S",
                UNSAFE_className: (0, $d7FTw$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($086e93d2352a4536$exports))), "spectrum-Icon")
            }
        }
    }, children)));
}
let $b43bd559b476d0c4$export$47dc48f595b075da = /*#__PURE__*/ (0, $d7FTw$react).forwardRef($b43bd559b476d0c4$var$FieldButton);


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 







function $45108e3c482ee88b$var$LogicButton(props, ref) {
    props = (0, $d7FTw$useProviderProps)(props);
    let { variant: variant, children: children, isDisabled: isDisabled, autoFocus: autoFocus, ...otherProps } = props;
    let domRef = (0, $d7FTw$useFocusableRef)(ref);
    let { buttonProps: buttonProps, isPressed: isPressed } = (0, $d7FTw$useButton)(props, domRef);
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $d7FTw$useHover)({
        isDisabled: isDisabled
    });
    let { styleProps: styleProps } = (0, $d7FTw$useStyleProps)(otherProps);
    return /*#__PURE__*/ (0, $d7FTw$react).createElement((0, $d7FTw$FocusRing), {
        focusRingClass: (0, $d7FTw$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($086e93d2352a4536$exports))), "focus-ring"),
        autoFocus: autoFocus
    }, /*#__PURE__*/ (0, $d7FTw$react).createElement("button", {
        ...styleProps,
        ...(0, $d7FTw$mergeProps)(buttonProps, hoverProps),
        ref: domRef,
        className: (0, $d7FTw$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($086e93d2352a4536$exports))), "spectrum-LogicButton", {
            [`spectrum-LogicButton--${variant}`]: variant,
            "is-disabled": isDisabled,
            "is-active": isPressed,
            "is-hovered": isHovered
        }, styleProps.className)
    }, /*#__PURE__*/ (0, $d7FTw$react).createElement("span", {
        className: (0, $d7FTw$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($086e93d2352a4536$exports))), "spectrum-Button-label")
    }, children)));
}
/**
 * A LogicButton displays an operator within a boolean logic sequence.
 */ let $45108e3c482ee88b$export$9b0b80fed00ba8b1 = /*#__PURE__*/ (0, $d7FTw$react).forwardRef($45108e3c482ee88b$var$LogicButton);


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 







function $dd24e555a16de2ae$var$ClearButton(props, ref) {
    let { children: children = /*#__PURE__*/ (0, $d7FTw$react).createElement((0, $d7FTw$spectrumiconsuiCrossSmall), {
        UNSAFE_className: (0, (/*@__PURE__*/$parcel$interopDefault($086e93d2352a4536$exports)))["spectrum-Icon"]
    }), focusClassName: focusClassName, variant: variant, autoFocus: autoFocus, isDisabled: isDisabled, preventFocus: preventFocus, elementType: elementType = preventFocus ? "div" : "button", ...otherProps } = props;
    let domRef = (0, $d7FTw$useFocusableRef)(ref);
    let { buttonProps: buttonProps, isPressed: isPressed } = (0, $d7FTw$useButton)({
        ...props,
        elementType: elementType
    }, domRef);
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $d7FTw$useHover)({
        isDisabled: isDisabled
    });
    let { styleProps: styleProps } = (0, $d7FTw$useStyleProps)(otherProps);
    // For cases like the clear button in a search field, remove the tabIndex so
    // iOS 14 with VoiceOver doesn't focus the button and hide the keyboard when
    // moving the cursor over the clear button.
    if (preventFocus) delete buttonProps.tabIndex;
    let ElementType = elementType;
    return /*#__PURE__*/ (0, $d7FTw$react).createElement((0, $d7FTw$FocusRing), {
        focusRingClass: (0, $d7FTw$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($086e93d2352a4536$exports))), "focus-ring", focusClassName),
        autoFocus: autoFocus
    }, /*#__PURE__*/ (0, $d7FTw$react).createElement(ElementType, {
        ...styleProps,
        ...(0, $d7FTw$mergeProps)(buttonProps, hoverProps),
        ref: domRef,
        className: (0, $d7FTw$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($086e93d2352a4536$exports))), "spectrum-ClearButton", {
            [`spectrum-ClearButton--${variant}`]: variant,
            "is-disabled": isDisabled,
            "is-active": isPressed,
            "is-hovered": isHovered
        }, styleProps.className)
    }, children));
}
let $dd24e555a16de2ae$export$13ec83e50bf04290 = /*#__PURE__*/ (0, $d7FTw$react).forwardRef($dd24e555a16de2ae$var$ClearButton);


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 









function $3979c7c23b0bd270$var$ToggleButton(props, ref) {
    props = (0, $d7FTw$useProviderProps)(props);
    let { isQuiet: isQuiet, isDisabled: isDisabled, isEmphasized: isEmphasized, staticColor: staticColor, children: children, autoFocus: autoFocus, ...otherProps } = props;
    let domRef = (0, $d7FTw$useFocusableRef)(ref);
    let state = (0, $d7FTw$useToggleState)(props);
    let { buttonProps: buttonProps, isPressed: isPressed } = (0, $d7FTw$useToggleButton)(props, state, domRef);
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $d7FTw$useHover)({
        isDisabled: isDisabled
    });
    let { styleProps: styleProps } = (0, $d7FTw$useStyleProps)(otherProps);
    let isTextOnly = (0, $d7FTw$react).Children.toArray(props.children).every((c)=>!/*#__PURE__*/ (0, $d7FTw$react).isValidElement(c));
    return /*#__PURE__*/ (0, $d7FTw$react).createElement((0, $d7FTw$FocusRing), {
        focusRingClass: (0, $d7FTw$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($086e93d2352a4536$exports))), "focus-ring"),
        autoFocus: autoFocus
    }, /*#__PURE__*/ (0, $d7FTw$react).createElement("button", {
        ...styleProps,
        ...(0, $d7FTw$mergeProps)(buttonProps, hoverProps),
        ref: domRef,
        className: (0, $d7FTw$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($086e93d2352a4536$exports))), "spectrum-ActionButton", {
            "spectrum-ActionButton--quiet": isQuiet,
            "spectrum-ActionButton--emphasized": isEmphasized,
            "spectrum-ActionButton--staticColor": !!staticColor,
            "spectrum-ActionButton--staticWhite": staticColor === "white",
            "spectrum-ActionButton--staticBlack": staticColor === "black",
            "is-active": isPressed,
            "is-disabled": isDisabled,
            "is-hovered": isHovered,
            "is-selected": state.isSelected
        }, styleProps.className)
    }, /*#__PURE__*/ (0, $d7FTw$react).createElement((0, $d7FTw$SlotProvider), {
        slots: {
            icon: {
                size: "S",
                UNSAFE_className: (0, $d7FTw$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($086e93d2352a4536$exports))), "spectrum-Icon")
            },
            text: {
                UNSAFE_className: (0, $d7FTw$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($086e93d2352a4536$exports))), "spectrum-ActionButton-label")
            }
        }
    }, typeof children === "string" || isTextOnly ? /*#__PURE__*/ (0, $d7FTw$react).createElement((0, $d7FTw$Text), null, children) : children)));
}
/**
 * ToggleButtons allow users to toggle a selection on or off, for example
 * switching between two states or modes.
 */ let $3979c7c23b0bd270$export$d2b052e7b4be1756 = /*#__PURE__*/ (0, $d7FTw$react).forwardRef($3979c7c23b0bd270$var$ToggleButton);




export {$b865a6f0049e2d66$export$353f5b6fc5456de1 as Button, $042ad0b3a4a55b33$export$cfc7921d29ef7b80 as ActionButton, $b43bd559b476d0c4$export$47dc48f595b075da as FieldButton, $45108e3c482ee88b$export$9b0b80fed00ba8b1 as LogicButton, $dd24e555a16de2ae$export$13ec83e50bf04290 as ClearButton, $3979c7c23b0bd270$export$d2b052e7b4be1756 as ToggleButton};
//# sourceMappingURL=module.js.map
